import request from '@/common/request'
import { DadosConsultaNF } from '@/models/DadosConsultaNF'

const PATH = '/nf/consulta'

export const consulta = async (chaveDeConsulta: string): Promise<DadosConsultaNF> =>
	await request.get(`${PATH}/${chaveDeConsulta}`)